<template>
  <div class="entrepreneurs-list">
    <div class="h-grid h-grid--row-gutter">
      <div class="h-grid__col h-grid__col--sm-4" v-for="entrepreneur in value" :key="entrepreneur.Id">
        <div class="entrepreneur__container">
          <strong style="flex-grow:1;">{{ entrepreneur.Name }}</strong>
          <div class="entrepreneur__container-btn">
            <button class="entrepreneur__edit-btn" @click="editEntrepreneur(entrepreneur)" type="button">{{ $t('entrepreneur-edit-btn') }}</button>
            <button class="entrepreneur__del-btn" @click="showDeleteEntrepreneur(entrepreneur)" type="button">{{ $t('entrepreneur-delete-btn') }}</button>
          </div>
        </div>
        <span class="entrepreneur__age" v-if="entrepreneur.Birthdate !== null">{{ $t('entrepreneur_age_text', { age: getEntrepreneurAge(entrepreneur) }) }}</span>
      </div>
    </div>

    <!-- Edit entrepreneur -->
    <div class="o-panel" v-show="selectedEntrepreneur !== null" v-bind:class="{ 'o-panel--open': this.selectedEntrepreneur }">
      <div class="o-panel__head">
        <h2 class="o-panel__title">{{ $t('dashboard-participate-entrepreneur-edit-title') }}</h2>
        <button type="button" class="o-panel__close" @click="hideEditEntrepreneurPanel">{{ $t('panel-close') }}</button>
      </div>
      <div class="o-panel__content">
        <entrepreneur-edit @onEntrepreneurSubmit="saveEntrepreneur" :submit-btn-label="$t('button-edit-entrepeneur')" :name="name" :month="month" :year="year" :gender="gender" />
      </div>
    </div>
    <div class="o-panel__overlay" @click="hideEditEntrepreneurPanel"></div>

    <!-- Delete entrepreneur -->
    <div class="o-panel" v-if="deletedEntrepreneur !== null" v-bind:class="{ 'o-panel--open': this.deletedEntrepreneur }">
      <div class="o-panel__head">
        <h2 class="o-panel__title">{{ $t('dashboard-participate-entrepreneur-delete-title') }}</h2>
        <button type="button" class="o-panel__close" @click="hideDeleteEntrepreneurPanel">{{ $t('panel-close') }}</button>
      </div>
      <div class="o-panel__content">
        <confirmation-popup :text="deleteEntrepreneurText" :actions="deleteEntrepreneurActions" />
      </div>
    </div>
    <div class="o-panel__overlay" @click="hideDeleteEntrepreneurPanel"></div>

    <!-- Delete entrepreneur error -->
    <div class="o-panel" v-if="showDeleteError" v-bind:class="{ 'o-panel--open': this.showDeleteError }">
      <div class="o-panel__head">
        <h2 class="o-panel__title">{{ $t('error-basic') }}</h2>
        <button type="button" class="o-panel__close" @click="hideDeleteEntrepreneurErrorPanel">{{ $t('panel-close') }}</button>
      </div>
      <div class="o-panel__content">
        <confirmation-popup :text="$t('delete-entrepreneur-error-text')" :actions="deleteEntrepreneurErrorActions" />
      </div>
    </div>
    <div class="o-panel__overlay" @click="hideDeleteEntrepreneurErrorPanel"></div>
  </div>
</template>

<script>
import ConfirmationPopup from '@/components/popup/confirmation-popup'
import EntrepreneurEdit from '@/components/form/entrepreneur-edit'

import EntrepreneurService from '@/services/entrepreneur'

import i18n from '@/helpers/i18n'

export default {
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  components: { ConfirmationPopup, EntrepreneurEdit },
  data() {
    return {
      selectedEntrepreneur: null,
      deletedEntrepreneur: null,
      showDeleteError: false,
      name: '',
      month: '',
      year: '',
      gender: 0,
      deleteEntrepreneurActions: [
        { key: 'deleteEntrepreneur_yes', label: this.$t('popup_confirm_label'), click: this.deleteEntrepreneur },
        { key: 'deleteEntrepreneur_no', label: this.$t('popup_dismiss_label'), click: this.hideDeleteEntrepreneurPanel }
      ],
      deleteEntrepreneurErrorActions: [
        { key: 'deleteEntrepreneurError_okay', label: this.$t('popup_okay_label'), click: this.hideDeleteEntrepreneurErrorPanel }
      ]
    }
  },
  computed: {
    deleteEntrepreneurText: function() {
      return i18n.t('delete-entrepreneur-panel-text').replace('{name}', this.deletedEntrepreneur.Name)
    }
  },
  methods: {
    editEntrepreneur(entrepreneur) {
      this.selectedEntrepreneur = entrepreneur
      this.name = entrepreneur.Name

      let birthdate = new Date(entrepreneur.Birthdate)
      this.month = birthdate.getMonth()
      this.year = birthdate.getFullYear()
      this.gender = entrepreneur.Gender
    },
    hideEditEntrepreneurPanel() {
      this.selectedEntrepreneur = null
      this.name = ''
      this.month = ''
      this.year = ''
      this.gender = 0
    },
    hideDeleteEntrepreneurPanel() {
      this.deletedEntrepreneur = null
    },
    hideDeleteEntrepreneurErrorPanel() {
      this.showDeleteError = false
    },
    showDeleteEntrepreneur(entrepreneur) {
      this.deletedEntrepreneur = entrepreneur
    },
    async deleteEntrepreneur() {
      try {
        await EntrepreneurService.deleteEntrepreneur(this.deletedEntrepreneur.Id)
      }
      catch (error) {
        this.showDeleteError = true
        this.deletedEntrepreneur = null
        return
      }
      this.deletedEntrepreneur = null
      this.$emit('entrepreneurUpdated')
    },
    async saveEntrepreneur(entrepreneur) {
      let date = null
      
      if (entrepreneur.year !== '' && entrepreneur.month !== '') {
        date = new Date(entrepreneur.year, entrepreneur.month, 1)
      }

      let request = {
        entrepreneurId: this.selectedEntrepreneur.Id,
        name: { value: entrepreneur.name },
        birthdate: { value: date },
        gender: { value: entrepreneur.gender }
      }

      await EntrepreneurService.updateEntrepreneur(request)
      this.selectedEntrepreneur = null
      this.name = ''
      this.month = ''
      this.year = ''
      this.gender = 0

      this.$emit('entrepreneurUpdated')
    },
    getEntrepreneurAge(entrepreneur) {
      let ageDifMs = Date.now() - new Date(entrepreneur.Birthdate).getTime()
      let ageDate = new Date(ageDifMs)
      return Math.abs(ageDate.getUTCFullYear() - 1970)
    }
  }
}
</script>

<style lang="scss">
@media screen {
  .entrepreneurs-list {
    margin: 48px 0;
  }
}
.entrepreneur__age {
  border-bottom-width: thin;
  border-bottom-style: solid;
  display: flex;
}
.entrepreneur__container {
  display: flex;
}
.entrepreneur__container-btn {
  display: flex;
  justify-content: center;
  align-items: center;
}
.entrepreneur__edit-btn {
  text-align: center;
  appearance: none;
  background: transparent url(~@/assets/edit.svg) no-repeat center center;
  background-size: contain;
  border: 0;
  color: transparent;
  cursor: pointer;
  font: 0/0 a;
  height: 25px;
  margin: auto;
  padding: 0;
  text-shadow: none;
  white-space: nowrap;
  width: 25px;
}
.entrepreneur__del-btn {
  text-align: center;
  appearance: none;
  background: transparent url(~@/assets/delete_entrepreneur.svg) no-repeat center center;
  background-size: contain;
  border: 0;
  color: transparent;
  cursor: pointer;
  font: 0/0 a;
  height: 25px;
  margin: auto;
  padding: 0;
  text-shadow: none;
  white-space: nowrap;
  width: 25px;
}
</style>
